import { ComponentStyleConfig } from "@chakra-ui/react";
import { ThemeColor } from "../palette";

export const Heading: ComponentStyleConfig = {
    baseStyle: {
        fontWeight: "semibold",
        textColor: ThemeColor.KAIROS,
    },
};
